module.exports = __webpack_public_path__ + "img/tel_ok_gris.4cbf93df.png";